import { $http } from '@/utils';
const _iotCenter = true ? '/iot-center' : '';

/**
 * 采集点配置
 *
*/

// eslint-disable-next-line import/no-anonymous-default-export
export default {

    //采集点配置-获取采集点列表
    getPatchList(data) {
        return $http.get(_iotCenter + '/tree/collect/query', data);
    },

    //采集点配置-获取采集点详情
    getPatchDetail(data) {
        return $http.get(_iotCenter + '/tree/collect/findById', data);
    },

    //采集点配置-根据采集点查询采集点下的设备
    getPatchOfDeviceList(data) {
        return $http.get(_iotCenter + '/collect/point/device/'+ data.id +'/list', data);
    },
    //采集点配置-根据采集点查询采集点下的设备 所有设备会透传查询下级采集点
    getPatchOfDeviceListAll(data) {
        return $http.get(_iotCenter + '/collect/point/device/all/'+ data.id +'/list', data);
    },
    //获取采集点设置的时段信息回显
    getTimeFrameByPatch(data){
        return $http.get(_iotCenter + '/afn10/collect/point/configTimeIntervalRateRead2/list', data);
    },
    //下发时段设置到采集点
    writeTimeToOption(data){
        return $http.post(_iotCenter + `/afn10/config/collect/point/time/rate2`,data);
    },
    //采集点配置-删除采集点列表
    deletePatch(id) {
        return $http.post(_iotCenter + '/tree/collect/remove', null, {id});
    },

    //采集点配置-创建采集点
    createPatch(data) {
        return $http.post(_iotCenter + '/tree/collect/add', data);
    },

    //采集点配置-修改采集点
    updatePatch(data) {
        return $http.post(_iotCenter + '/tree/collect/modify', data);
    },

    //采集点配置-查询子设备列表
    getChildDeviceList(data) {
        return $http.get(_iotCenter + '/collect/point/device/'+ data.id +'/find/child/list', data);
    },

    //采集点配置-查询末添加到采集点的设备 -- 未分组的设备
    getUnPatchDeviceList(id) {
        return $http.get(_iotCenter + '/collect/point/device/ungrouped/list');
    },

    //采集点配置-添加设备到采集点
    addDevicesToPatch(data) {
        return $http.put(_iotCenter + '/collect/point/device/add/device/collect/point', data);
    },

    //采集点配置-从采集点列表删除设备
    deleteDeviceOfPatchList(id) {
        return $http.delete(_iotCenter + '/collect/point/device/'+ id +'/del');
    },

    //采集点配置-获取子采集点列表 分页
    getChildPatchList(data) {
        return $http.get(_iotCenter + '/tree/collect/queryChild', data);
    },

}
